import { useLocation } from 'react-router-dom';

import menuLinks from '../routes/menu/MenuUserLinks';

export const useWhatPageIsThis = () => {
  const location = useLocation();
  // Extrai somente o caminho, ignorando query strings
  const basePath = location.pathname.split('?')[0];

  // Encontra o item que melhor corresponde ao basePath
  const menuItem = menuLinks.find(item =>
    // Verifica se o basePath corresponde ao item.location exatamente ou se segue com uma barra
    (basePath === item.location || basePath.startsWith(item.location + '/'))
  );

  return {
    icon: menuItem && <menuItem.icon size={25} weight="duotone" />,
    title: menuItem?.title,
    description: menuItem?.description,
  };
};